export default "/images/smart_contracts_development/nft_security.png";